import { useEffect } from 'react';

const ADMINLTE_STYLES = [
  {
    id: 'adminlte-font-source',
    href: 'https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700&display=fallback',
  },
  {
    id: 'adminlte-fontawesome',
    href: 'https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@5.15.4/css/all.min.css',
  },
  {
    id: 'adminlte-bootstrap',
    href: 'https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css',
  },
  {
    id: 'adminlte-core',
    href: 'https://cdn.jsdelivr.net/npm/admin-lte@3.2/dist/css/adminlte.min.css',
  },
];

/**
 * Load AdminLTE 3 styles only while the dashboard is mounted.
 * @see https://adminlte.io/themes/v3/
 */
export function useAdminLTEAssets() {
  useEffect(() => {
    const nodes = ADMINLTE_STYLES.map(({ id, href }) => {
      if (document.getElementById(id)) return null;
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.id = id;
      document.head.appendChild(link);
      return link;
    });

    document.documentElement.classList.add('dashboard-scroll-root');
    document.body.classList.add('hold-transition', 'dashboard-app-active');

    return () => {
      nodes.forEach((node) => node?.remove());
      document.documentElement.classList.remove('dashboard-scroll-root');
      document.body.classList.remove(
        'hold-transition',
        'dashboard-app-active',
        'sidebar-mini',
        'layout-fixed',
        'login-page',
        'sidebar-collapse'
      );
    };
  }, []);
}

export function setAdminLTEBodyMode({ login = false, collapsed = false } = {}) {
  document.body.classList.toggle('login-page', login);
  document.body.classList.toggle('sidebar-mini', !login);
  // layout-fixed locks body scroll in SPAs — use normal document scroll instead
  document.body.classList.remove('layout-fixed');
  document.body.classList.toggle('sidebar-collapse', !login && collapsed);
}
